module.exports = __webpack_public_path__ + "media/images/tl/banner/vi-light-pc-64432c9035fd5e355ef09542c44eecbf.jpg";